import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=f3c01ae8&scoped=true"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"
import style0 from "./richText.vue?vue&type=style&index=0&id=f3c01ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c01ae8",
  null
  
)

export default component.exports